export const USER_ROLES = {
  TEACHER: "teacher",
  PARENT: "parent",
  CENTER: "center super admin",
  CEO: "center ceo owner",
};
